import React, { useEffect, useState } from 'react'
import { BsTrash } from 'react-icons/bs'
import { FaGooglePay } from 'react-icons/fa'
import { MdOutlineVerifiedUser } from 'react-icons/md'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { deleteVerifiedBankAccountAction, getVerifiedBankAccountAction } from '../../routes/financier/FinancierDuck'
import Button from '../button'
import Tag from '../tag'
import Text from '../text'
import * as styles from './VerifiedDepositAccounts.css'

const DropDown = ({ data }) => {
  const displayDataForKeys = ['bankName', 'holderName', 'ifsc', 'accountNumber', 'vpa']

  return (
    <div className={styles.dropDown}>
      {Object.keys(data).map(accountKey => {
        return (
          displayDataForKeys.includes(accountKey) &&
          data[accountKey] && (
            <div key={accountKey} className={styles.dropDownItems}>
              <Text size='0.82' color='#808B96' bold>
                {accountKey.toUpperCase()}
              </Text>
              <Text size='0.95' color='hsla(0, 0%, 30%, 1)'>
                {data[accountKey]}
              </Text>
            </div>
          )
        )
      })}
    </div>
  )
}

export const VerifiedDepositAccounts = () => {
  const { authAxios } = useAxios()
  const {
    financierState: { financier, depositAccounts },
  } = useGlobal()
  const { financierDispatch } = useGlobalDispatch()

  const verifiedColor = 'hsla(161, 94%, 30%, 1)'
  const upiColor = 'hsla(262, 83%, 58%, 1)'

  const [showMoreIndex, setShowMoreIndex] = useState(9999)

  useEffect(() => {
    getVerifiedBankAccountAction(financier?.financierPAN)(authAxios, financierDispatch)
  }, [])

  const handleDeleteAccount = account => {
    deleteVerifiedBankAccountAction(
      account,
      financier?.financierId,
      financier?.financierPAN
    )(authAxios, financierDispatch)
  }

  return (
    <div className={styles.container}>
      {depositAccounts?.length ? (
        depositAccounts.map((account, index) => {
          return (
            // Hide Dropdown when same header is clicked again
            <div key={index} onClick={() => setShowMoreIndex(prevIndex => (prevIndex === index ? 9999 : index))}>
              <div className={styles.header}>
                {account?.type === 'upi' ? (
                  <div>
                    <Text>{account?.vpa}</Text>
                  </div>
                ) : (
                  <div>
                    <Text>
                      {account?.bankName} — {account?.accountNumber}
                    </Text>
                  </div>
                )}

                <div className={styles.buttonsView}>
                  <div className={styles.tagsView}>
                    {account?.type === 'upi' && (
                      <Tag icon={<FaGooglePay color={upiColor} size={20} />} text={'UPI'} color={upiColor} />
                    )}
                    {account?.verified && (
                      <Tag
                        icon={<MdOutlineVerifiedUser color={verifiedColor} />}
                        text={'Verified'}
                        color={verifiedColor}
                      />
                    )}
                  </div>
                  <Button type={'icon'} onClick={() => handleDeleteAccount(account)}>
                    <BsTrash size={16} />
                  </Button>
                </div>
              </div>
              {showMoreIndex === index && <DropDown data={account} />}
            </div>
          )
        })
      ) : (
        <div>
          <Text>Add your bank account to process deposits to the wallet</Text>
        </div>
      )}
    </div>
  )
}
